import { useEffect } from 'react';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import inactiveAccountMascot from '../assets/inactive-account-mascot.svg';

/**
 * Terminal page for admins that Auth0 redirects here when they reach Metabase before the
 * nightly subscription job has provisioned their reporting role (BR-258). It is reachable
 * without a Roadmaps session; Header and Footer already collapse to just the logo in that
 * case, so it renders inside LayoutWrapper like the rest of the routes.
 */
const MetabaseAccessPending = () => {
  const navigate = useNavigate();

  // Auth0's redirect API always appends its `state` resume token to the URL. Nothing here
  // resumes the login, and the token does not belong in screenshots, bookmarks or pasted
  // links, so drop it from the address bar and from the history entry.
  useEffect(() => {
    if (window.location.search) {
      window.history.replaceState(null, '', window.location.pathname);
    }
  }, []);

  return (
    <div className="tw-min-h-screen tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-px-4 tw-text-center">
      <img
        src={inactiveAccountMascot}
        alt="Relaxed mascot wearing sunglasses and sipping a juice box"
        className="tw-w-36 tw-h-36"
      />
      <h1 className="tw-text-2xl tw-font-bold tw-text-neutral-900 tw-m-0">You don&apos;t have access to this page</h1>
      <p className="tw-text-base tw-text-neutral-700 tw-m-0">Go back to Roadmaps or contact support for help.</p>
      <Button
        label="Back to Roadmaps"
        icon="pi pi-arrow-left"
        iconPos="left"
        rounded
        onClick={() => navigate('/')}
        className="tw-mt-2"
      />
    </div>
  );
};

export default MetabaseAccessPending;
